import { useTranslation } from 'react-i18next'
import { Accordion } from 'react-bootstrap'
import { ILearningPathCard } from 'models/learningPathCard.model'
import { CategoryHeader, EmptyState, AccordionToggle } from '../../atoms'
import { LearningPathSlider } from '../learning-path-slider'
import styles from './LearningPathSection.module.scss'

interface Props {
  title: string
  subtitle?: string
  learningPaths: ILearningPathCard[]
  totalLearningPaths: number
  viewMore: {
    href: string
    text?: string
  }
  emptyState?: {
    text?: string
    link: {
      href: string
      text: string
    }
  }
}

export const LearningPathSection: React.FC<Props> = ({
  learningPaths,
  totalLearningPaths,
  viewMore,
  title,
  subtitle,
  emptyState,
}) => {
  const { t } = useTranslation()

  if (!learningPaths || (learningPaths.length === 0 && !emptyState)) return null

  return (
    <Accordion className={styles.root} defaultActiveKey={title}>
      <AccordionToggle eventKey={title}>
        <CategoryHeader
          title={title}
          subtitle={subtitle}
          count={totalLearningPaths || 0}
          showMoreLink={viewMore.href}
          showMoreText={viewMore.text || t('availableCourses.showMore')}
        />
      </AccordionToggle>
      <Accordion.Collapse eventKey={title}>
        {learningPaths && learningPaths.length ? (
          <LearningPathSlider learningPaths={learningPaths} />
        ) : (
          <EmptyState
            text={emptyState?.text || t('learningPaths.section.empty')}
            link={
              emptyState && {
                href: emptyState.link.href,
                text: emptyState.link.text,
              }
            }
          />
        )}
      </Accordion.Collapse>
    </Accordion>
  )
}
